import { FeatureFlag } from "../hooks/use-feature-flag"

export const splitIOLocalhostFeatureFlags = {
  [FeatureFlag.REBRAND_V2_MONOLITH_REACT]: "on",
  [FeatureFlag.NO_APARTMENT_REDIRECT]: "on",
  [FeatureFlag.NEW_STILL_HAVE_QUESTIONS_DESIGN]: "on",
  [FeatureFlag.NEW_GET_STARTED_PAGE]: "on",
  [FeatureFlag.ENABLE_FOOTER_TRUST_CENTER]: "on",
  [FeatureFlag.ENABLE_FOOTER_MARKETPLACE]: "on",
  [FeatureFlag.ENABLE_FOOTER_BLOG_RENAME]: "on",
  [FeatureFlag.REMOVE_FOOTER_CONTACT_US]: "on",
  [FeatureFlag.REN_5067_UNENROLLED_FLOW]: "on",
  [FeatureFlag.REN_5245_RENTERS_FLOW_AB_TEST]: "on",
  [FeatureFlag.REN_5179_UNENROLLED_FLOW]: "on",
  [FeatureFlag.REN_5179_UNENROLLED_FLOW_AB_TEST]: "on"
}
